import { useState, useEffect, useRef } from "react";

const videos = [
  { id: "5aYIBdS95WA?si=5W4W9xgzq2B52Pll", title: "MG Comet - 10,000 KMs Long Term Review | @MotorBeam" },
  { id: "lU1PJGimBa4?si=VQtCwSy9f9O_JMGe", title: "MG Comet Blackstorm Walkaround - BAAS Costing Explained! | @MotorBeam" },
  { id: "P_zQXLSZfJE?si=wksUP9ccEekpb4mA", title: "MG Comet EV | Long Term Review | BaaS Explained | Motoroids" },
  { id: "LpAN19VRU18?si=r2568sYLx0v_Dd1h", title: "MG Comet EV: Perfect City Car? Full Review - Range, Life time Battery Warranty & 4-Passenger Space!" },
  { id: "vcbomCYGMx0?si=xekvy1M0sCze4vUa", title: "MG Comet EV - BAAS Explained | @MGMotorIndia | AutoMatta" },
  { id: "5UWmczT70v4?si=Wr43AtIWPPx-7SDc", title: "MG Comet meets MG Midget - Size is everything | Feature | Autocar India" },
  { id: "I5l7MA7cgwo?si=SC7U5FXd8dMzP4Er", title: "MG Comet EV Long Term Review: Living with the Comet for 2500 kms" },
];

const GAP = 20;
const TITLE_HEIGHT = 70; // fixed title area height in px

export default function MGCometAutoExpertReviews() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const wrapperRef = useRef(null);

  // Observe wrapper width changes
  useEffect(() => {
    if (!wrapperRef.current) return;
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });
    ro.observe(wrapperRef.current);
    setContainerWidth(wrapperRef.current.getBoundingClientRect().width);
    return () => ro.disconnect();
  }, []);

  // 1 card on mobile, 2 on tablet+
  const visibleCount = containerWidth > 0 && containerWidth < 580 ? 1 : 2;
  const cardWidth = containerWidth > 0
    ? (containerWidth - GAP * (visibleCount - 1)) / visibleCount
    : 0;
  const maxIndex = videos.length - visibleCount;

  useEffect(() => {
    setCurrentIndex((i) => Math.min(i, Math.max(0, maxIndex)));
  }, [maxIndex]);

  const prev = () => setCurrentIndex((i) => Math.max(0, i - 1));
  const next = () => setCurrentIndex((i) => Math.min(maxIndex, i + 1));

  // Exact pixel offset per slide step
  const translateX = currentIndex * (cardWidth + GAP);

  // iframe height = 56.25% of card width (16:9)
  const iframeHeight = cardWidth > 0 ? Math.round(cardWidth * 0.5625) : 0;
  const totalCardHeight = iframeHeight + TITLE_HEIGHT;

  return (
    <div style={{ fontFamily: "'Georgia', serif", background: "#fff", padding: "60px 0 80px" }}>
      <style>{`
        .comet-nav-btn {
          width: 46px; height: 46px; border-radius: 10px;
          background: #c0001d; border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          color: #fff; font-size: 1.5rem; font-weight: bold;
          transition: background 0.2s, transform 0.15s;
          flex-shrink: 0;
        }
        .comet-nav-btn:hover:not(:disabled) { background: #900015; transform: scale(1.07); }
        .comet-nav-btn:disabled { opacity: 0.35; cursor: not-allowed; }
        .comet-dot {
          width: 9px; height: 9px; border-radius: 50%;
          background: #ddd; border: none; padding: 0; cursor: pointer;
          transition: background 0.2s, transform 0.2s;
        }
        .comet-dot.active { background: #c0001d; transform: scale(1.35); }
        .comet-card {
          transition: box-shadow 0.3s, transform 0.25s;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
          border-radius: 6px;
          overflow: hidden;
          background: #fff;
        }
        .comet-card:hover {
          box-shadow: 0 8px 32px rgba(192,0,29,0.14);
          transform: translateY(-3px);
        }
      `}</style>

      <h2 style={{
        textAlign: "center", color: "#c0001d",
        fontSize: "clamp(1.3rem, 3.5vw, 2.1rem)", fontWeight: "700",
        marginBottom: "40px", fontFamily: "'Georgia', serif",
      }}>
        Auto Expert Reviews
      </h2>

      {/* Outer wrapper — sets the container we measure */}
      <div style={{ maxWidth: "1320px", margin: "0 auto", padding: "0 20px" }}>
        <div ref={wrapperRef} style={{ overflow: "hidden", width: "100%" }}>
          {/* Track — pixel-translated */}
          <div style={{
            display: "flex",
            gap: `${GAP}px`,
            transform: `translateX(-${translateX}px)`,
            transition: "transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            willChange: "transform",
            alignItems: "flex-start",
          }}>
            {videos.map((v, i) => (
              <div
                key={i}
                className="comet-card"
                style={{
                  width: `${cardWidth}px`,
                  minWidth: `${cardWidth}px`,
                  maxWidth: `${cardWidth}px`,
                  height: `${totalCardHeight}px`,
                  flexShrink: 0,
                  flexGrow: 0,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* 16:9 iframe — exact pixel height */}
                <div style={{
                  width: "100%",
                  height: `${iframeHeight}px`,
                  background: "#000",
                  flexShrink: 0,
                  position: "relative",
                }}>
                  <iframe
                    src={`https://www.youtube.com/embed/${v.id}`}
                    title={v.title}
                    allowFullScreen
                    loading="lazy"
                    style={{
                      position: "absolute", top: 0, left: 0,
                      width: "100%", height: "100%", border: "none",
                    }}
                  />
                </div>

                {/* Title — fixed height, clamp overflow */}
                <div style={{
                  height: `${TITLE_HEIGHT}px`,
                  padding: "10px 10px 8px",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  fontFamily: "'Arial', sans-serif",
                  color: "#222",
                  lineHeight: 1.4,
                  boxSizing: "border-box",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                }}>
                  {v.title}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Nav row */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "14px", marginTop: "32px" }}>
          <button className="comet-nav-btn" onClick={prev} disabled={currentIndex === 0} aria-label="Previous">‹</button>
          
          <button className="comet-nav-btn" onClick={next} disabled={currentIndex >= maxIndex} aria-label="Next">›</button>
        </div>
      </div>
    </div>
  );
}